(() => {
  if (customElements.get('dalji-look-selection')) return;
  class LookSelection extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      this.cards = [...this.querySelectorAll('[data-look-card]')];
      this.button = this.querySelector('[data-look-add]');
      this.track = this.querySelector('[data-look-track]');
      this.addEventListener('change', () => this.update(), options);
      this.addEventListener('click', event => {
        const target = event.target.closest('button');
        if (!target) return;
        if (target.hasAttribute('data-look-details')) target.closest('[data-look-card]').querySelector('dialog').showModal();
        if (target.hasAttribute('data-look-close')) target.closest('dialog').close();
        if (target.hasAttribute('data-look-add')) this.add();
        if (target.hasAttribute('data-look-prev') || target.hasAttribute('data-look-next')) this.track.scrollBy({left:this.track.clientWidth * (target.hasAttribute('data-look-prev') ? -.8 : .8),behavior:'smooth'});
      }, options);
      this.cards.forEach(card => card.querySelector('dialog').addEventListener('click', event => {
        const dialog = event.currentTarget, bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      }, options));
      document.addEventListener('variant:changed', event => {
        const select = this.cards[0]?.querySelector('[data-look-variant]');
        if (select && event.detail?.variant && [...select.options].some(option => option.value === String(event.detail.variant.id))) {
          select.value = String(event.detail.variant.id);
          this.update();
        }
      }, options);
      this.track.addEventListener('scroll', () => this.navigation(), options);
      this.resize = new ResizeObserver(() => this.navigation());
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() { this.events?.abort(); this.resize?.disconnect(); this.ready = false; }
    money(price) {
      if (window.FoxTheme?.Currency) return window.FoxTheme.Currency.formatMoney(price, window.FoxTheme.settings.moneyFormat);
      return new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(price / 100);
    }
    selected() { return this.cards.filter(card => card.querySelector('[data-look-select]').checked); }
    update() {
      this.cards.forEach(card => {
        const select = card.querySelector('[data-look-variant]'), check = card.querySelector('[data-look-select]');
        const unavailable = !select.value || select.selectedOptions[0]?.disabled;
        check.disabled = unavailable;
        if (unavailable) check.checked = false;
      });
      // The whole box is unavailable if any product has no sellable variant.
      const outOfStock = this.cards.some(card =>
        ![...card.querySelector('[data-look-variant]').options].some(option => !option.disabled));
      const mainUnavailable = this.cards[0]?.querySelector('[data-look-variant]').selectedOptions[0]?.disabled;
      this.hidden = outOfStock || Boolean(mainUnavailable);
      const selected = this.selected();
      const policy = window.DaljiComboPolicy;
      const discount = !this.hidden && Boolean(policy?.allowed(
        this.cards.map(card => policy.fromCard(card,'[data-look-variant]')))) && Boolean(policy?.allowed(
        selected.map(card => policy.fromCard(card,'[data-look-variant]'))));
      const heading = this.querySelector('[data-look-heading]');
      if (heading) heading.textContent = discount ? 'Complete o look e economize' : 'Complete o look';
      let total = 0;
      this.cards.forEach(card => {
        const checked = selected.includes(card);
        const price = Number(card.querySelector('[data-look-variant]').selectedOptions[0]?.dataset.price || 0);
        const discounted = checked && discount;
        const effective = discounted ? Math.round(price * (100 - Number(this.dataset.discountPercent)) / 100) : price;
        const original = card.querySelector('[data-look-original]');
        original.hidden = !discounted;
        original.innerHTML = this.money(price);
        card.querySelector('[data-look-price]').innerHTML = this.money(effective);
        card.querySelector('[data-look-detail-price]').innerHTML = discounted ? `<s>${this.money(price)}</s> <strong>${this.money(effective)}</strong>` : this.money(price);
        card.dataset.selected = String(checked);
        card.dataset.discounted = String(discounted);
        if (checked) total += effective;
      });
      this.querySelector('[data-look-total]').innerHTML = this.money(total);
      this.button.querySelector('span').textContent = 'Adicionar';
      this.querySelector('[data-look-count]').textContent = `${selected.length} ${selected.length === 1 ? 'item selecionado' : 'itens selecionados'}`;
      this.button.disabled = this.hidden || this.busy || !selected.length;
      this.querySelector('[data-look-status]').textContent = `${selected.length} itens selecionados. Total ${this.money(total)}.`;
      this.navigation();
    }
    navigation() {
      this.querySelector('[data-look-prev]').disabled = this.track.scrollLeft <= 2;
      this.querySelector('[data-look-next]').disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    }
    async add() {
      this.update();
      if (this.hidden || this.busy) return;
      const selected = this.selected();
      if (!selected.length) return;
      const items = selected.map(card => ({id:card.querySelector('[data-look-variant]').value,quantity:1}));
      this.busy = true;
      this.update();
      const error = this.querySelector('[data-look-error]');
      error.hidden = true;
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Não foi possível adicionar a seleção. Tente novamente.');
        if (typeof window.bndlr?.updateCartDiscounts === 'function') window.bndlr.updateCartDiscounts();
        if (document.querySelector('cart-drawer') && window.FoxTheme?.settings.cartType === 'drawer') document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
        else window.location.assign(`${root}cart`);
      } catch (reason) { error.textContent = reason.message; error.hidden = false; }
      finally { this.busy = false; this.update(); }
    }
  }
  customElements.define('dalji-look-selection', LookSelection);
})();
